export default {
  floatingTopMenu: {
    'openSettings': 'Impostazioni',
    'showAbout': 'Mostra informazioni generali',
    'about': 'Chi siamo',
    'openrouteserviceAPI': 'Openrouteservice API',
    'openrouteserviceForDisasters': 'Openrouteservice per catastrofi',
    'askOpenrouteservice': 'Chiedi a openrouteservice',
    'settingsTooltip': 'Clicca qui se vuoi cambiare le impostazioni dell\'applicazione o vedere altre opzioni'
  }
}
